import { TextFilterProps } from '@progress/kendo-react-data-tools'
import { useAppSelector } from 'store'

import { SelectFilter } from '../SelectFilter'

export const AppropriatenessTestSubcategoryFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const appropriatenessTestSubCategories = useAppSelector(
    (state) => state.clients.appropriatenessTestSubCategories
  )
  const data = appropriatenessTestSubCategories.map((x) => ({
    id: x.id,
    label: x.name,
    value: x.id,
  }))

  return (
    <SelectFilter
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
      style={{ width: 240 }}
    />
  )
}
